import Toast from 'components/toasts/Toast'
import { Times } from 'components/icons'


export default function ErrorToast({children}) {
  return <Toast icon={<Times/>}>{children}</Toast>
}